import React from 'react';

import Header from '@/core/components/Header';
import Modal from '@/core/components/Modal';
import BlockProfileForm from '@/core/components/ProfileActions/BlockProfileForm';
import ScrollDownItem from '@/core/components/ScrollDownItem';
import useDisclosure from '@/core/hooks/useDisclosure';
import type { BlockAction } from '@/core/lib/new-architecture/domain/user.domain';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface BlockActionComponentProps {
  action: BlockAction;
  onSuccess: () => void;
}

const BlockActionComponent: React.FC<BlockActionComponentProps> = ({ action, onSuccess }) => {
  const { t } = useTranslationContext(['profile.actions']);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <ScrollDownItem icon="block" content={t(action.text, { ns: 'profile.actions' })} type="button" onClick={onOpen} />
      <Modal type="popup" isOpen={isOpen} onClose={onClose}>
        <Header content={t('block.title', { ns: 'profile.actions' })} iconAfter="close" onAfter={onClose} />
        <BlockProfileForm
          uuid={action.uuid}
          onClose={() => {
            onClose();
            onSuccess();
          }}
        />
      </Modal>
    </>
  );
};

export default BlockActionComponent;
